import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import { faBox, faRocket } from "@fortawesome/free-solid-svg-icons";

import InformationInput from "./Application/InformationInput";
import Identification from "./Application/Identification";
import CreateApplicationModalWizard from "../../UI/Modal/CreateApplicationModalWizard";

import * as PathUtils from "../../Utils/PathUtils";
import * as ApplicationConstant from "../../Constants/ApplicationConstant";
import * as ApplicationsUtils from "../../Utils/ApplicationsUtils";
import * as ApplicationsActions from "../../../middleware/Store/Actions/ApplicationsActions";
import * as SandBoxApplicationsActions from "../../../middleware/Store/Actions/SandBoxApplicationsActions";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "APPLICATION_CREATE";

const ApplicationCreate = (props) => {

    const intl = useIntl();
    const history = useHistory();
    const [criteria, setCriteria] = useState(null);
    const [modal, setModal] = useState(null);
    const [isSandBoxApplication, setIsSandBoxApplication] = useState(false);
    const [createApplication, setCreateApplication] = useState(() => props.createApplication);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect didmount");
        if (ApplicationsUtils.isApplicationCreatePath(props.location)) {
            if (ApplicationsUtils.isSandBoxApplication(props.location)) {
                setIsSandBoxApplication(true);
                setCreateApplication(() => props.createSandBoxApplication);
            }
        }
    }, [props.location]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect didmount");
        let title = intl.messages.applicationCreateButton;
        let icon = faRocket;
        let iconColor = "";
        if (isSandBoxApplication) {
            title = intl.messages.sandBoxApplicationCreateButton;
            icon = faBox;
            iconColor = "green";
        }

        setModal(
            <CreateApplicationModalWizard
                title={title}
                icon={icon}
                getComponent={getComponent}
                action={handleAction}
                disableFirstButton={!criteria || !criteria.name || criteria.name.length === 0}
                onClose={handleOnClose}
                iconColor={iconColor}
            />
        );
    }, [criteria, isSandBoxApplication]);

    const getComponent = (updateEnabled) => {
        return (
            <InformationInput
                name={criteria?.name}
                activity={criteria?.activity}
                type={criteria?.type}
                isUpdateEnabled={updateEnabled}
                onUpdate={handleInputUpdate}
            />);
    }

    const getSuccessComponent = (applicationId) => {
        return (
            <Identification
                applicationId={applicationId}
                showHeader={false}
                isUpdateEnabled={false}
                isSandBoxApplication={isSandBoxApplication}
            />);
    }

    const handleInputUpdate = (name, activity, type) => {
        LogService.trace(LOG_TAG, "handleInputUpdate");
        setCriteria({
            name: name,
            activity: activity,
            type: type
        });
    }

    const handleAction = () => {
        LogService.trace(LOG_TAG, "handleAction");

        if (criteria) {
            return createApplication(criteria.name, criteria.activity, criteria.type)
                .then((application) => {
                    LogService.debug(LOG_TAG, "handleAction", application);
                    return Promise.resolve({
                        title: intl.messages.applicationCreateSuccessfullMessage,
                        component: getSuccessComponent(application.id),
                        action: handleApplicationEdit,
                        applicationId: application.id
                    });
                })
                .catch((errorPayload) => {
                    return Promise.reject({
                        title: intl.messages.applicationCreateFailedMessage,
                        errorMessage: errorPayload.errorMessage
                    });
                });
        } else {
            return Promise.reject({
                title: intl.messages.applicationCreateFailedMessage,
                errorMessage: intl.messages.applicationCreateFailedNoInputMessage
            });
        }
    }

    const handleApplicationEdit = (appId) => {
        LogService.trace(LOG_TAG, "handleApplicationEdit");
        let path = PathUtils.addOrUpdateQueryParameterToPathString(ApplicationConstant.APPLICATION_PATH + ApplicationConstant.EDIT_PATH, ApplicationConstant.ApplicationTagName, appId);
        if (isSandBoxApplication) {
            path = PathUtils.addOrUpdateQueryParameterToPathString(path, ApplicationConstant.ApplicationSandBoxTagName, true);
        }
        history.replace(path);
    };

    const handleOnClose = () => {
        LogService.trace(LOG_TAG, "handleOnClose");
        history.goBack();
    };

    LogService.trace(LOG_TAG, "render");

    return (
        <div>
            {modal}
        </div>
    );
}

ApplicationCreate.defaultProps = {
}

ApplicationCreate.propTypes = {
};

const mapDispatchToProps = dispatch => {
    return {
        createApplication: (name, activity, type) => dispatch(ApplicationsActions.createApplication(name, activity, type)),
        createSandBoxApplication: (name, activity, type) => dispatch(SandBoxApplicationsActions.createApplication(name, activity, type))
    }
}

export default connect(null, mapDispatchToProps)(ApplicationCreate);
